import React, { useEffect, useState } from "react";
import { useLeaveData } from "../../../hooks/leaveData";

const Employee = ({ employees, isLoadingEmployees }) => {
    const { setLeaveData, leaveData } = useLeaveData();

    const [activeEmployee, setActiveEmployee] = useState(null);

    useEffect(() => {
        setActiveEmployee(null);
    }, [leaveData?.year])

    const handleSetCurrentEmployee = (uname) => {
        setActiveEmployee(uname);
        setLeaveData('employee', uname);
    }

    return (
        <div className='employees'>
            <div className='panel'>
                <div className='panel-title'>
                    <h3>Employees</h3>
                </div>
                <div className='panel-content'>
                    <ul className={isLoadingEmployees ? 'loading' : ''}>
                        {isLoadingEmployees 
                            ? (
                                [...Array(10)].map((_, i) => (
                                    <li key={i}><span></span></li>
                                ))
                            ) : (
                                employees?.map((item, i) => (
                                    <li key={i} className={activeEmployee === item.uname ? 'active' : ''} onClick={() => handleSetCurrentEmployee(item.uname)}>
                                        <span>{item.fname} {item.lname}</span>
                                    </li>
                                ))
                            )
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Employee;